import React from 'react';
import PropTypes from 'prop-types';

// Import components
import './imageWithTextModule.scss';
import Picture from '../../Util/Picture/Picture';

const ImageWithTextView = props => (
  <div className="m-article-module">
    <div className={'m-image-text-module'}>
      <div className={'m-image-text-module__image'}>
        <Picture
          src={{
            sm: props.src['620'],
            md: props.src['445'],
            lg: props.src['620'],
            xl: props.src['620'],
            xxl: props.src['620'],
            xxxl: props.src['1020'],
            default: props.src.default,
          }}
          alt={props.alt}
          imageCollection={[props]}
        />
        <div className="m-image-text-module__desc" dangerouslySetInnerHTML={{ __html: props.desc }} />
      </div>
      <div className="m-image-text-module__text" dangerouslySetInnerHTML={{ __html: props.text }} />
    </div>
  </div>
);

ImageWithTextView.propTypes = {
  src: PropTypes.shape(),
  text: PropTypes.node,
  desc: PropTypes.string,
  alt: PropTypes.string,
};

ImageWithTextView.defaultProps = {
  src: {},
  text: null,
  desc: '',
  alt: '',
};

export default ImageWithTextView;




// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/ImageWithTextModule/ImageWithTextModuleView.jsx